import React, { useState } from 'react';
import { Accordion, Card } from 'react-bootstrap';
import { Mail, Phone, MapPin, HelpCircle, ChevronDown, MessageCircle, Book } from 'lucide-react';
import './Ayuda.css';

const Ayuda = () => {
  const [activeKey, setActiveKey] = useState(null);

  const faqs = [
    {
      pregunta: '¿Cómo me conecto con su API?',
      respuesta: 'Para conectarte con nuestra API, necesitas obtener un token de acceso, para esto ve a la sección "Consultar" y ahí verás tu token de acceso, para ver la documentación ingresa a https://api.sat-go.com/swagger/index.html. También puedes mirar este video en youtube que explica paso a paso  como conectarte: https://youtu.be/rWvSRzAzxtQ'
    },
    {
      pregunta: '¿Cómo descargo mi opinión de cumplimiento mediante API?',
      respuesta: 'Sigue los pasos en este video: https://youtu.be/8ATToaY7ewI'
    },
    {
      pregunta: '¿Cómo descargo mis comprobantes mediante API?',
      respuesta: 'Sigue los pasos en este video: https://youtu.be/rGIuZzD3FAc'
    },
    {
      pregunta: '¿Cómo agregar un nuevo RFC?',
      respuesta: 'Para agregar un nuevo RFC, ve a la sección "Mis RFC" y haz clic en el botón "Agregar Nuevo RFC". Ingresa el RFC de 13 caracteres y haz clic en "Guardar". Eso sucede de forma automática cuanto utilizas nuestra API.'
    },
    {
      pregunta: '¿Cómo actualizar la información de un RFC?',
      respuesta: 'En la lista de RFCs, encuentra el RFC que deseas actualizar. Los cambios se reflejarán automáticamente en el sistema del SAT.'
    },
    {
      pregunta: '¿Cómo puedo consultar un CSF, opinión de cumplimiento o descarga de facturas?',
      respuesta: 'Utiliza la sección "Consultar" e ingresa el RFC que deseas verificar. Selecciona el tipo de consulta (CSF, Opinion de Cumplimiento, etc.) y sigue las instrucciones en pantalla. De igual manera puedes hacerlo mediante nuestra API SAT-GO, puedes ver la documentación en:https://api.sat-go.com/swagger/index.html te sugerimos utilizar la versión 2.0.'
    },
    {
      pregunta: '¿Cómo cambiar mi contraseña?',
      respuesta: 'Ve a la sección de "Configuración" y busca la opción "Cambiar Contraseña" en el panel de Seguridad. Sigue los pasos para actualizar tu contraseña de forma segura.'
    },
    {
      pregunta: '¿Qué es la CIEC y dónde la encuentro?',
      respuesta: 'La CIEC (Clave de Identificación Electrónica Confidencial) es tu contraseña del SAT. Puedes generarla o recuperarla en el portal oficial del SAT.'
    },
    {
      pregunta: '¿Cómo descargar mi Constancia de Situación Fiscal?',
      respuesta: 'En la sección "Consultar", selecciona "Constancia de Situacion Fiscal", elige tu RFC, ingresa tu CIEC, resuelve el captcha y descarga el documento.'
    }
  ];

  return (
    <div className="ayuda-container">
      <div className="page-header mb-4">
        <div>
          <h2 className="page-title">Centro de Ayuda</h2>
          <p className="page-subtitle text-muted">Encuentra respuestas rápidas a tus preguntas</p>
        </div>
      </div>
      {/* Contact Cards */}
      <div className="row g-4 mb-5">
        <div className="col-md-4">
          <Card className="contact-card border-0 shadow-sm h-100">
        <Card.Body className="p-4 text-center">
          <div className="contact-icon-wrapper mb-3">
            <Mail size={28} />
          </div>
          <h5 className="mb-2">Email</h5>
          <p className="text-muted mb-3">Envíanos un correo</p>
          <a href="mailto:soporte@satgo.mx" className="contact-link">
            soporte@satgo.mx
          </a>
        </Card.Body>
          </Card>
        </div>

        <div className="col-md-4">
          <Card className="contact-card border-0 shadow-sm h-100">
          <Card.Body className="p-4 text-center">
            <div className="contact-icon-wrapper mb-3">
              <MessageCircle size={28} />
            </div>
            <h5 className="mb-2">Chat en Vivo</h5>
            <p className="text-muted mb-3">Chatea con nosotros</p>
            <a
              href="https://wa.me/529981957130"
              className="contact-link"
              target="_blank"
              rel="noopener noreferrer"
            >
              Iniciar Chat
            </a>
          </Card.Body>
          </Card>
        </div>
      </div>

        {/* FAQ Section */}
      <Card className="faq-section border-0 shadow-sm">
        <Card.Header className="faq-header">
          <div className="d-flex align-items-center">
            <div className="header-icon-wrapper me-3">
              <HelpCircle size={24} />
            </div>
            <div>
              <h4 className="mb-0">Preguntas Frecuentes</h4>
              <p className="mb-0 small text-white-50 mt-1">Encuentra respuestas a las preguntas más comunes</p>
            </div>
          </div>
        </Card.Header>
        <Card.Body className="p-4">
          <Accordion activeKey={activeKey} onSelect={(key) => setActiveKey(key)}>
            {faqs.map((faq, index) => (
              <Accordion.Item eventKey={index.toString()} key={index} className="faq-item">
                <Accordion.Header className="faq-question">
                  <div className="d-flex align-items-center w-100">
                    <Book size={18} className="me-3 question-icon" />
                    <span className="flex-grow-1">{faq.pregunta}</span>
                  </div>
                </Accordion.Header>
                <Accordion.Body className="faq-answer">
                  {faq.respuesta}
                </Accordion.Body>
              </Accordion.Item>
            ))}
          </Accordion>
        </Card.Body>
      </Card>

      {/* Additional Help */}
      <Card className="additional-help border-0 shadow-sm mt-4">
        <Card.Body className="p-4">
          <div className="row align-items-center">
            <div className="col-md-8">
              <h5 className="mb-2">¿Aún necesitas ayuda?</h5>
              <p className="text-muted mb-0">
                Nuestro equipo de soporte está disponible de Lunes a Viernes de 9:00 AM a 6:00 PM (Hora del Centro de México)
              </p>
            </div>
            <div className="col-md-4 text-md-end mt-3 mt-md-0">
              <a href="mailto:soporte@satgo.mx" className="btn btn-contact">
                <Mail size={18} className="me-2" />
                Contactar Soporte
              </a>
            </div>
          </div>
        </Card.Body>
      </Card>
    </div>
  );
};

export default Ayuda;
